import { Injectable } from '@angular/core';
import { BaseHttpService } from './base-http.service';
import { ProfileViewModel } from '../models/generated-view-models';
import { URLS } from '../shared/url';
import { Observable } from 'rxjs';
import { ResponseTypeEnum } from '../models/enums';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {

  constructor(
    private http: BaseHttpService) { }

  public getUserProfile = (): Observable<ProfileViewModel> => {
      return this.http.Get(URLS.getUserProfile);
  }

  public saveUserProfile = (user: ProfileViewModel): Observable<boolean> => {
      return this.http.Post(URLS.saveUserProfile, user, ResponseTypeEnum.Success);
  }
}
